import { createAction, props } from '@ngrx/store';
import { LanguageModel } from '../models/create-new-integration.model';

export const NameEnboxChange = createAction(
  '[ENBOX CONFIGURATION]: Name Enbox Changed',
  props<{ nameEnbox: string }>(),
);

export const StatusEnboxChange = createAction(
  '[ENBOX CONFIGURATION]: Status Enbox Changed',
  props<{ isActiveEnbox: boolean }>(),
);

export const ExternalIdEnboxChange = createAction(
  '[ENBOX CONFIGURATION]: External ID Enbox Changed',
  props<{ externalIdEnbox: string }>(),
);

export const LanguagesEnboxChange = createAction(
  '[ENBOX CONFIGURATION]: Languages Enbox Changed',
  props<{ selectedLanguageEnbox: LanguageModel[] }>(),
);

export const AdmissionFeeEnboxChange = createAction(
  '[ENBOX CONFIGURATION]: Admission Fee Enbox Changed',
  props<{ admissionFeeEnbox: number | null }>(),
);

export const CreditCostEnboxChange = createAction(
  '[ENBOX CONFIGURATION]: Credit Cost Enbox Changed',
  props<{ creditCostEnbox: number | null }>(),
);

export const SegmentsRetentionDaysEnboxChange = createAction(
  '[ENBOX CONFIGURATION]: Segments Retention Days Enbox Changed',
  props<{ segmentsRetentionDaysEnbox: number | null }>(),
);

export const BaseUrlEnboxChange = createAction(
  '[ENBOX CONFIGURATION]: Base URL Enbox Changed',
  props<{ baseUrlEnbox: string }>(),
);

export const ReadTimeoutEnboxChange = createAction(
  '[ENBOX CONFIGURATION]: Read Timeout Enbox Changed',
  props<{ readTimeoutEnbox: number | null }>(),
);

export const ConnectionTimeoutEnboxChange = createAction(
  '[ENBOX CONFIGURATION]: Connection Timeout Enbox Changed',
  props<{ connectionTimeoutEnbox: number | null }>(),
);

export const ApiKeyEnboxChange = createAction(
  '[ENBOX CONFIGURATION]: API Key Enbox Changed',
  props<{ apiKeyEnbox: string }>(),
);

export const EmailNotifierChange = createAction(
  '[ENBOX CONFIGURATION]: Email Notifier Change',
  props<{ emailNotifier: string }>(),
);

export const LookBackDaysChange = createAction(
  '[ENBOX CONFIGURATION]: Look Back Days Change',
  props<{ lookBackDays: number | null }>(),
);

export const SaveEnboxConfiguration = createAction(
  '[ENBOX CONFIGURATION]: Save Enbox Configuration',
);

export const SaveEnboxConfigurationSuccess = createAction(
  '[ENBOX CONFIGURATION]: Save Enbox Configuration Success',
  props<{ res: any }>(),
);

export const SaveEnboxConfigurationFailed = createAction(
  '[ENBOX CONFIGURATION]: Save Enbox Configuration Failed',
  props<{ error: any }>(),
);

export const UpdateEnboxConfiguration = createAction(
  '[ENBOX CONFIGURATION]: Update Enbox Configuration',
);

export const UpdateEnboxConfigurationSuccess = createAction(
  '[ENBOX CONFIGURATION]: Update Enbox Configuration Success',
  props<{ res: any }>(),
);

export const UpdateEnboxConfigurationFailed = createAction(
  '[ENBOX CONFIGURATION]: Update Enbox Configuration Failed',
  props<{ error: any }>(),
);

export const ToggleRootConfHelpTextStatus = createAction(
  '[ENBOX CONFIGURATION]: Toggle Root Configuration Help Text Status',
);

export const ToggleCredentialsConfHelpTextStatus = createAction(
  '[ENBOX CONFIGURATION]: Toggle Credentials Configuration Help Text Status',
);

export const ToggleCampaignReportingHelpTextStatus = createAction(
  '[ENBOX CONFIGURATION]: Toggle Campaign Reporting Help Text Status',
);

export const ToggleEndpointConfHelpTextStatus = createAction(
  '[ENBOX CONFIGURATION]: Toggle Endpoint Configuration Help Text Status',
);

export const EditEnboxIntegrationSystem = createAction(
  '[ENBOX CONFIGURATION]: Edit Enbox Integration System',
  props<{ enboxData: any }>(),
);

export const CloseEnboxEditIntegration = createAction(
  '[ENBOX CONFIGURATION]:   Close Enbox Edit Integration',
);

export const EnboxSubmitData = createAction('[ENBOX CONFIGURATION]: Enbox Submit Data');
